var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import SubmitServiceApi from '~/api/submission-engine/submitService';
import { keysToCamel } from '~/utils/toCamelCase';
const searchDocuments = (searchDocuments, setSearchedDocuments, setQueryInfo, searchText) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = keysToCamel(yield SubmitServiceApi.search(searchDocuments.length, 100, searchText));
        setSearchedDocuments([...searchDocuments, ...response.data]);
        setQueryInfo({
            totalDocuments: response.totalNoOfDocuments,
            documentsFetched: response.totalDocumentsFetched,
        });
    }
    catch (e) {
        console.error(e);
    }
});
export default searchDocuments;
